import React, { useState } from 'react';
import ToolsGate from './ToolsGate';
import DonationPopup from './DonationPopup';

const ACCESS_KEY = 'as_tools_access';

export default function ProtectedRoute({ children }) {
  const [authed, setAuthed] = useState(() => sessionStorage.getItem(ACCESS_KEY) === 'true');

  if (!authed) {
    return (
      <ToolsGate
        onSuccess={() => {
          sessionStorage.setItem(ACCESS_KEY, 'true');
          setAuthed(true);
        }}
      />
    );
  }

  return (
    <>
      {children}
      <DonationPopup />
    </>
  );
}
